import dayjs from "dayjs"
import { t } from "i18next"
import { Period } from "../../@client/Absents"

export function getFormattedPeriod(
  value: Period,
  dateFormat: string = "ddd\u00A0L",
  withoutTime: boolean = false
): string {
  const startDate = dayjs(value.startDate).format(dateFormat)
  const endDate = dayjs(value.endDate).format(dateFormat)
  const startTime = withoutTime
    ? undefined
    : value.startTime
      ? dayjs("0000-00-00 " + value.startTime).format("LT")
      : ""
  const endTime = withoutTime
    ? undefined
    : value.endTime
      ? dayjs("0000-00-00 " + value.endTime).format("LT")
      : ""
  let result = ""
  if (startDate === endDate) {
    result += startDate
    if (startTime && endTime) {
      result += ` ${startTime}-${endTime}`
    } else if (startTime) {
      result += ` ${t("From_LowerCase")}\u00A0${startTime}`
    } else if (endTime) {
      result += ` ${t("To_LowerCase")}\u00A0${endTime}`
    }
  } else {
    result += startDate
    if (startTime) {
      result += `\u00A0${startTime}`
    }
    result += " - "
    result += endDate
    if (endTime) {
      result += `\u00A0${endTime}`
    }
  }
  return result
}
